import { ActivityId } from '@gyym/sdk'

import { useActivity } from '@/modules/Activities'

import { useFacilitiesMeta } from './useFacilitiesMeta'

export const useFacilitiesMetaActivity = (id?: ActivityId) => {
  const { data } = useFacilitiesMeta()

  const metaActivity = data?.activities.find((activity) => activity.id === id)

  const { data: activity } = useActivity(metaActivity ? undefined : id)

  return metaActivity || activity
}
